import Component from '@glimmer/component';

export default class extends Component {
  headerBarLinks = [
    {
      route: 'funds.fund.contacts',
      models: [],
      label: 'All Contacts',
    },
    {
      route: 'funds.fund.groups',
      models: [],
      label: 'By Group',
    },
  ];
}
